<template>
    <v-menu
        ref="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
    >
        <template v-slot:activator="{ on, attrs }">
            <div style="display:flex;align-items: center;">
            <div     v-bind="attrs"
                v-on="on" :style="`border-radius:999999px;width:2rem;height: 2rem; background-color:${color}`">

            </div>
            <h5 style="padding-left:1rem">
                {{ color }}
            </h5>
        </div>
        </template>
        <v-color-picker v-model="color" >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
            <v-btn text color="primary" @click="$refs.menu.save(fecha)">
                OK
            </v-btn>
        </v-color-picker>
    </v-menu>
</template>
<script>
    export default {
        props:['label','value','name'],
        data(){
            return{color:"#000000",}
        },
        created(){
            this.color = this.value;
        },
        updated(){
            if(this.color != this.value)
                this.color = this.value;
        },
        watch:{
            value(){
                this.color = this.value;
            },
            color(){
                this.$emit('input', this.color)
            }
        },
         methods:{
         
    
        }

    }
</script>
